import React from 'react'
import { withTranslation } from 'react-i18next'
import { formatDate, getHours } from '../../lib/lib'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class WebinarMiniCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    routeToWebinar(id) {
        if (Number(this.props.props.match.params.webinarId) !== id) {
            this.props.props.history.push(`/webinar/${this.props.id}`)
            window.location.reload()
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="webinars-webinar-mini-card">
                            <div className="mini-card-header w-100">
                                <div className="title md-font-size"><Skeleton count={2} /></div>
                                <div className="datetime xs-font-size w-100">
                                    <div className="date w-25 mr-20px p-0"><Skeleton /></div>
                                    <div className="time w-25"><Skeleton /></div>
                                </div>
                            </div>
                            <div className="mini-card-body w-100">
                                <div className="desc"><Skeleton count={5} /></div>
                            </div>
                        </div>
                        :
                        <div className="webinars-webinar-mini-card">
                            <div className="mini-card-header">
                                <div className="title md-font-size" onClick={() => this.routeToWebinar(this.props.id)}>{this.props.title}</div>
                                <div className="datetime xs-font-size">
                                    <div className="date">{formatDate(this.props.date)}</div>
                                    <div className="time">В {getHours(this.props.date)}</div>
                                </div>
                            </div>
                            <div className="mini-card-body">
                                <div className="desc" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

WebinarMiniCard.propTypes = {
    props: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.number,
    desc: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(WebinarMiniCard)



// WEBPACK FOOTER //
// ./src/components/Webinars/WebinarMiniCard.jsx